import React, {Component} from 'react';
import TableFilter from '../TableFilter'
import OrganizzazioniTable from './OrganizzazioniTable'
import OrganizzazioniReportList from './OrganizzazioniReportList'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import OrganizzazioneForm from './OrganizzazioneForm'
import RubricaOggettiOrfani from './RubricaOggettiOrfani'
import {createInstance} from '../../Helpers';
import PropTypes from 'prop-types';
import RubricaElencoOrganizzazioni from "../../pdf/RubricaElencoOrganizzazioni";

class OrganizzazioniList extends Component {
    constructor(props) {
        super(props);
        this.rowperpage = client.getDefaultRowsPerPage();
        this.state = {
            items: [],
            total: 0,
            page: 1,
            orderInfo: {
                columnName: 'nome',
                direction: 'A',
                data: [{field: 'o.nome', direction: 'A'}]},
            filterInfo: {},
            _loading: false,
            error: null,
            showItem: null,
            listViewType: 'l',
            statoOrganizzazione: 'S',
            organizzazioneInEdit: undefined,
            organizzazioneSaved: undefined,
        };
        this.storeInstance = createInstance();
        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeColumnOrder = this.onChangeColumnOrder.bind(this)
        this.onDeleteClick = this.onDeleteClick.bind(this)
        this.onNewClick = this.onNewClick.bind(this)
        this.onEditClick = this.onEditClick.bind(this)
        this.loadData = this.loadData.bind(this)
        this.renderList = this.renderList.bind(this)
        this.onOrganizzazioneStateChange = this.onOrganizzazioneStateChange.bind(this)
        this.onChangeMostraOrfani = this.onChangeMostraOrfani.bind(this)
        this.getStartPageByListViewType = this.getStartPageByListViewType.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
        this.pdfExport = this.pdfExport.bind(this)
    }

    getFilterDescription() {
        let msg = '';
        if (this.state.filterInfo.keyword !== undefined && this.state.filterInfo.keyword !== ''){
            msg += 'Nome contenente: ' + this.state.filterInfo.keyword;
        }
        return  msg.trim();
    }


    componentWillMount() {
    }

    componentWillUnmount() {
        if (this.storeInstance) {
            this.storeInstance.save('OrganizzazioniList', this.state);
        }
    }

    cfgLoaded(cfg, error){
        if (cfg !== undefined){
            this.setState({cfg});
        }
    }

    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('OrganizzazioniList', this , () => {

                if (this.props.location.state && this.props.location.state.item && this.props.location.state.from)
                {
                    if (this.props.location.state.from.pathname.includes("organizzazioni/edit"))
                    {
                        let organizzazione = this.props.location.state.item.organizzazione;
                        let items = this.state.items.map((cit) => {
                            if (cit.idOrganizzazione === organizzazione.idOrganizzazione)
                            {
                                return organizzazione;
                            }
                            return cit;
                        });
                        this.setState({items: items, showItem: organizzazione});
                    }
                    else if (this.props.location.state.from.pathname.includes("organizzazioni/new"))
                    {
                        let organizzazione = this.props.location.state.item.organizzazione;
                        let items = [organizzazione];
                        this.setState({items: items.concat(this.state.items), showItem: organizzazione});
                    }
                }
                else {
                    this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
                }
            }) === null){
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }
    }

    getStartPageByListViewType(){
        return this.state.listViewType === 'l' ? 1 : -1;
    }

    onChangePage(newpage) {

        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo)
    }

    onChangeColumnOrder(columnName, direction, data) {
        let newOrderInfo = {
            columnName: columnName,
            direction: direction,
            data: data
        }
        this.loadData(this.getStartPageByListViewType(), newOrderInfo, this.state.filterInfo)
    }

    onChangeFilter(data){
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, data)
    }

    onChangeMostraOrfani(mostraOrfani){
        let fi = this.state.filterInfo;
        fi.mostraOrfani = mostraOrfani;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, fi);
    }

    pdfExport(tipo){
        this.loadCompleteData(tipo, this.state.orderInfo, this.state.filterInfo);
    }

    loadCompleteData(tipo, orderInfo, filterInfo) {
        this.setState({_loading: true});
        client.loadOrganizzazioniList(
            this.rowperpage,
            -1,
            orderInfo.data,
            filterInfo, true
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        _loading: false,
                        error: null,
                    }, ()=>{
                        let ce = new RubricaElencoOrganizzazioni();
                        ce.setTitle("Report Organizzazioni");
                        ce.setFileName("report-organizzazioni.pdf");
                        ce.setFilterDescription(this.getFilterDescription());
                        ce.createPdf(data.items);

                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    loadData(page, orderInfo, filterInfo) {
        this.setState({_loading: true});
        client.loadOrganizzazioniList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo, true
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null,
                        showItem: null,
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    onNewClick(){
        this.setState({statoOrganizzazione:'N'})
    }

    onEditClick(organizzazione){
        this.setState({statoOrganizzazione:'E', organizzazioneInEdit: organizzazione})
    }

    onOrganizzazioneStateChange(statoOrganizzazione, organizzazione, forceUpdate = false){
        let prevState = this.state.statoOrganizzazione;
        this.setState({
            statoOrganizzazione: statoOrganizzazione,
            organizzazioneSaved: organizzazione,
        });
        if (organizzazione !== undefined){
            if (prevState !== 'S' || forceUpdate){
                if (prevState === 'E') {
                    // Vengo da un edit
                    let items = this.state.items.map((cit) => {
                        if (cit.idOrganizzazione === organizzazione.idOrganizzazione)
                        {
                            return organizzazione;
                        }
                        return cit;
                    });
                    this.setState({items: items});
                }
                else {
                    // Vengo da un'aggiunta.
                    let items = [organizzazione];
                    this.setState({items: items.concat(this.state.items)});
                }
            }
        }
    }

    onDeleteClick(ev, organizzazione){
        this.setState({_loading: true});
        client.deleteOrganizzazione(organizzazione).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo)
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });

    }

    cambiaTipoLista(tipo) {
        this.setState({listViewType: tipo}, () => {
            if (tipo === 'r'){
                //Ricarico senza paginazione
                this.loadData(-1, this.state.orderInfo, this.state.filterInfo);
            } else if (this.state.page === -1){
                // Vengo dalla visualzizzazione report, reimposto la pagina a 1
                this.loadData(1, this.state.orderInfo, this.state.filterInfo);
            }
        });
    }

    renderOrganizzazione() {
        return (
            <OrganizzazioneForm
                idOrganizzazione={this.state.statoOrganizzazione === 'N' ? undefined : this.state.organizzazioneInEdit.idOrganizzazione}
                onSaved={(organizzazione) => (this.onOrganizzazioneStateChange('S', organizzazione))}
                onCancel={(organizzazione) => (this.onOrganizzazioneStateChange('S', organizzazione))}
            />
        )
    }

    renderList() {
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                    <div className="ui huge loader"></div>
                </div>
            );
        }
        return (<div className="ui">
            <h3 className="ui top block attached header">
                <div className="ui two column grid">
                    <div className="column">
                        <div className="ui green label">{this.state.total}</div> Organizzazioni soddisfano i filtri specificati
                    </div>
                    <div className="right aligned column">
                        <div className="ui ">
                            {/*<ListTypeButton*/}
                                {/*listType={this.state.listViewType}*/}
                                {/*onButtonClick={(t) => {this.cambiaTipoLista(t)}}*/}
                            {/*/>*/}
                        </div>
                    </div>
                </div>
            </h3>
            <div className="ui attached segment">
                <div className="ui two column stackable grid">
                    <div className="twelve wide column">
                        <TableFilter
                        showPopup={true}
                        value={this.state.filterInfo.keyword}
                        placeholder="Filtra organizzazione per nome..."
                        onChangeFilter={this.onChangeFilter} />
                    </div>
                    <div className="four wide column">
                        <RubricaOggettiOrfani
                            label="Mostra Organizzazioni senza Dipartimenti"
                            mostraOrfani={this.state.filterInfo.mostraOrfani}
                            onChange={this.onChangeMostraOrfani}
                        />

                    </div>
                </div>
            </div>

            {
                this.state.listViewType === 'l' ? (

                    <OrganizzazioniTable
                        items={this.state.items}
                        senderList={this.state.senderList}
                        count={this.state.total}
                        page={this.state.page}
                        rowperpage={this.rowperpage}
                        tableOrderingField={this.state.orderInfo.columnName}
                        tableOrderingDirection={this.state.orderInfo.direction}
                        onChangePage={this.onChangePage}
                        onChangeOrder={this.onChangeColumnOrder}
                        onDeleteItem={this.onDeleteClick}
                        onNuovoItem={this.onNewClick}
                        onModificaItem={this.onEditClick}
                        filterDescription={this.getFilterDescription()}
                        onExportPdf={this.pdfExport}
                        readOnly={client.getCurrentUser().isrolerubricaw===false}
                    />)

                    :

                    <OrganizzazioniReportList
                        items={this.state.items}
                        filterDescription={this.getFilterDescription()}
                    />

            }
            {loader}
        </div>)
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={() => {this.setState({error:null})}} />)
        }

        if (this.state.statoOrganizzazione !== 'S'){
            return (
                <div>
                    {this.renderOrganizzazione()}
                </div>
            )
        }

        return this.renderList()
    }
}

OrganizzazioniList.contextTypes = {
    router: PropTypes.object
}

export default OrganizzazioniList;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/OrganizzazioniList.js
 **/